import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from "@angular/material/card";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from "@angular/material/select";
import { ActivatedRoute } from '@angular/router';
import { finalize } from 'rxjs';
import { AuthenticationService } from '../../services/authentication.service';
import { NotificationService } from '../../services/notification.service';
import { UsersService } from '../../services/users.service';
import { BreadcrumbsComponent } from "../../shared/breadcrumbs/breadcrumbs.component";
import { LoadingComponent } from "../../shared/loading/loading.component";

@Component({
  selector: 'app-user-profile',
  imports: [LoadingComponent, MatFormFieldModule, CommonModule, MatCardModule, ReactiveFormsModule, MatInputModule, MatSelectModule, BreadcrumbsComponent],
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.scss'
})
export class UserProfileComponent implements OnInit {
  keycloakId: string = '';
  name: string | null = null;
  userInfo: any = {};
  isLoading = false;
  formDataProfile!: FormGroup;

  // Opzioni select "role"
  roleSelectOptions = [{ value: '', label: '' }];

  constructor(
    private readonly route: ActivatedRoute,
    private readonly fb: FormBuilder,
    private readonly usersService: UsersService,
    private readonly authenticationService: AuthenticationService,
    private readonly notificationService: NotificationService
  ) { }

  ngOnInit(): void {

    this.formDataProfile = this.fb.group({
      firstName: [''],
      lastName: [''],
      email: [''],
      password: [null],
      role: ['']
    });
    
    this.keycloakId = this.authenticationService.getKeycloakId();
    this.usersService.getLoggedUserInfo(this.keycloakId).subscribe((user)=> {
      this.userInfo = user
      this.formDataProfile.patchValue({
        firstName: this.userInfo.firstName,
        lastName: this.userInfo.lastName,
        email: this.userInfo.email,
        role: this.userInfo.role
      });
    });

    // Recupero ruoli per la select
    this.usersService.getRolesList().subscribe({
      next: (response) => {
        const roleOptions = response as Array<{ value: string; label: string }>;
        this.roleSelectOptions = roleOptions.map((x: any) => ({
          value: x.toUpperCase(),
          label: x
        }));
      },
      error: () => {
        this.roleSelectOptions = [];
      }
    });

  }

  isViewer(): boolean {
    return this.authenticationService.hasRole('BACKOFFICE_VIEWER');
  }

  onSubmitProfileData() {
    if (this.formDataProfile.valid) {
      this.isLoading = true;

      if(this.isViewer()){
        const payload = {
          id:this.keycloakId,
          password: this.formDataProfile.get('password')?.value
        }
        console.log('payload viewer: ', payload);
        this.usersService.changePassword(payload).pipe(finalize(() => { this.isLoading = false; })).subscribe({
          next: () => {
            this.notificationService.successOnSave();
            this.formDataProfile.get('password')?.reset();
          },
          error: (err) => {
            console.log('errore nella richiesta', err);
            this.notificationService.genericError();
          }
        })

      } else {
        const payload = {
          ...this.formDataProfile.value,
          id: this.keycloakId
        };
        console.log('payload completo (admin): ', payload);

        this.usersService.editUser(payload).pipe(finalize(() => { this.isLoading = false; })).subscribe({
          next: () => {
            this.notificationService.successOnSave();
            this.formDataProfile.get('password')?.reset();
          },
          error: (err) => {
            console.log('errore nella richiesta', err);
            this.notificationService.genericError();
          }
        });
      }
      
      
    } else {
      this.formDataProfile.markAllAsTouched();
    }
  }

}
